import { DarkTokens, HighContrastTokens, LightTokens } from '@sas/graph-tokens/js';
import { callStructWithArgs } from '../../render/react';
import colors from '../colors';
import { graphAxisLines, graphBackFill, graphDataNode, graphDataStyle, graphDataText, graphDefault, graphFocus, graphGridLines, graphKPIRange, graphLabelText, graphNodeDetails, graphNodeGroupClosed, graphNodeGroupOpen, graphNodeGroupTitle, graphNodeLabel, graphNodeLink, graphNodeTitle, graphOutlines, graphOutlinesUnfilled, graphOverviewAxis, graphOverviewAxisFilter, graphOverviewBorderLines, graphOverviewFill, graphOverviewFilterFill, graphOverviewViewportBorderLines, graphSelection, graphTargetNode, graphThreeColorRamp, graphValueText, graphWallFill } from '../patterns';
export function renderReactGraphTokens(theme, parameters) {
  let graphThemeTokens = LightTokens;
  switch (theme.baseThemeName) {
    case 'high-contrast':
      graphThemeTokens = HighContrastTokens;
      break;
    case 'dark':
      graphThemeTokens = DarkTokens;
      break;
  }
  const tokens = {
    ...graphThemeTokens.tokens
  };
  const gt = {
    // new tokens
    tokens,
    // old tokens
    /**
     * @deprecated Use gt.tokens instead.
     */
    c: callStructWithArgs(colors, theme),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphAxisLines: graphAxisLines(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphBackfill: graphBackFill(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphDataNode: callStructWithArgs(graphDataNode, theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphDataStyle: callStructWithArgs(graphDataStyle, theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphDataText: graphDataText(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphDefault: graphDefault(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphFocus: graphFocus(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphGridLines: graphGridLines(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphKPIRange: callStructWithArgs(graphKPIRange, theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphLabelText: graphLabelText(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeDetails: graphNodeDetails(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeGroupClosed: graphNodeGroupClosed(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeGroupOpen: graphNodeGroupOpen(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeGroupTitle: graphNodeGroupTitle(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeLabel: graphNodeLabel(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeLink: graphNodeLink(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphNodeTitle: graphNodeTitle(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOutlines: graphOutlines(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOutlinesUnfilled: graphOutlinesUnfilled(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewAxis: graphOverviewAxis(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewAxisFilter: graphOverviewAxisFilter(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewBorderLines: graphOverviewBorderLines(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewFill: graphOverviewFill(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewFilterFill: graphOverviewFilterFill(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphOverviewViewportBorderLines: graphOverviewViewportBorderLines(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphSelection: graphSelection(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphTargetNode: graphTargetNode(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphThreeColorRamp: callStructWithArgs(graphThreeColorRamp, theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphValueText: graphValueText(theme, parameters),
    /**
     * @deprecated Use gt.tokens instead.
     */
    graphWallFill: graphWallFill(theme, parameters)
  };
  return gt;
}
//# sourceMappingURL=react.js.map